import { RealizationCoreBase } from "./realization.core.base"


export class RealizationCore extends RealizationCoreBase {

}